import React, { useEffect, useRef } from "react"
import * as Icons from "lucide-react"

export default function EmailFolderContextMenu({
  x,
  y,
  folder,
  canManage,
  onClose,
  onAction,
}) {
  const ref = useRef(null)
  const hasId = Boolean(folder?.folder_id)

  useEffect(() => {
    const handleClick = event => {
      if (ref.current && !ref.current.contains(event.target)) onClose()
    }
    document.addEventListener("mousedown", handleClick)
    return () => document.removeEventListener("mousedown", handleClick)
  }, [onClose])

  const items = [
    { label: "Mark All as Read", icon: Icons.MailCheck, action: "markAllRead", disabled: !hasId },
    { label: "Clean Up Folder", icon: Icons.Sparkles, action: "cleanUp", disabled: !hasId, confirm: true },
    { label: "Delete All", icon: Icons.Trash2, action: "deleteAll", disabled: !hasId, confirm: true, danger: true },
    { type: "divider" },
    { label: "Properties", icon: Icons.Info, action: "properties", disabled: !hasId },
    { type: "divider" },
    { label: "New Folder", icon: Icons.FolderPlus, action: "newFolder" },
    { label: "Rename Folder", icon: Icons.Pencil, action: "renameFolder", disabled: !canManage },
    { label: "Delete Folder", icon: Icons.FolderX, action: "deleteFolder", disabled: !canManage, confirm: true, danger: true },
    { type: "divider" },
    { label: "Move Up", icon: Icons.ChevronUp, action: "moveUp", disabled: !hasId },
    { label: "Move Down", icon: Icons.ChevronDown, action: "moveDown", disabled: !hasId },
  ]

  const menuWidth = 220
  const menuHeight = items.length * 31 + 12
  const left = Math.min(x, window.innerWidth - menuWidth - 10)
  const top = Math.min(y, window.innerHeight - menuHeight - 10)

  return (
    <div ref={ref} className="em-context-menu em-folder-context-menu" style={{ left, top }}>
      {items.map((item, index) => {
        if (item.type === "divider") return <div key={index} className="em-context-menu-divider" />
        return (
          <button
            key={item.action}
            type="button"
            className="em-context-menu-item"
            disabled={item.disabled}
            style={item.danger ? { color: "#c62828" } : undefined}
            onClick={() => {
              if (!item.disabled) {
                onAction(item.action, folder, item.confirm)
                onClose()
              }
            }}
          >
            <item.icon size={14} />
            <span>{item.label}</span>
          </button>
        )
      })}
    </div>
  )
}
